import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SharedService } from '../../../../../shared/shared.service';
import { MethodOfPaymentService } from '../../method-of-payment.service';
import { MethodsOfPaymnetsArry } from './method-of-paymnet-array';
import { Location } from '@angular/common';
import notify from 'devextreme/ui/notify';
import { RepositionScrollStrategy } from '@angular/cdk/overlay';
import { UsefulToolsService } from '../../../../../shared/other/usefultools.service';


@Component({
  selector: 'app-method-of-payment-edit',
  templateUrl: './method-of-payment-edit.component.html',
  styleUrls: ['./method-of-payment-edit.component.css']
})
export class MethodOfPaymentEditComponent implements OnInit {

  popupVisible = false;
  dataSource: MethodsOfPaymnetsArry;
  paymentId = sessionStorage.getItem('payment-id');
  sessionId = sessionStorage.getItem('com-session-id');

  constructor(
    public sharedService: SharedService,
    public payment: MethodOfPaymentService,
    private httpClient: HttpClient,
    private location: Location,
    private usefultoolsservice: UsefulToolsService,
  ) { }

  ngOnInit() {
    this.sharedService.loadingActive = true;
    if (this.payment.payment === 1) {
      this.dataSource = {NAME: '', NOTES: ''};
      this.sharedService.loadingActive = false;
    } else if (this.payment.payment === 0) {
      // tslint:disable-next-line:max-line-length
      this.httpClient.get<any>(`${this.sharedService.URL}/dbMethodOfPayment?SessionID=${this.sessionId}&Search=${this.paymentId}`).subscribe(Response => {
        this.dataSource = Response.dbMethodOfPayment_response.view[0];
        this.sharedService.loadingActive = false;
      });
    } else {
      this.sharedService.loadingActive = false;
      this.location.back();
    }
  }

  onFormSubmit() {

    // validation

    if (this.dataSource.NAME === '' || this.dataSource.NAME === null) {
      this.usefultoolsservice.notify('error', `Name is required`);
      return;
    }

    const postThis = {
      SessionID: sessionStorage.getItem('com-session-id'),
      MethodOfPayment: [this.dataSource]
    };

    if (this.payment.payment === 1) {
      this.httpClient.post<any>(`${this.sharedService.URL}/dbMethodOfPayment`, postThis).subscribe(Response => {
        if (Response.dbMethodOfPayment_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbMethodOfPayment_response.ServiceResults[0].RESULTACTION === 'insert') {
          this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successInsert);
          this.location.back();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbMethodOfPayment_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
      });
    } else if (this.payment.payment === 0) {
      this.httpClient.put<any>(`${this.sharedService.URL}/dbMethodOfPayment`, postThis).subscribe(Response => {
        if (Response.dbMethodOfPayment_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbMethodOfPayment_response.ServiceResults[0].RESULTACTION === 'updateinsert') {
          this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successUpdate);
          this.location.back();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbMethodOfPayment_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
      });
    }
  }

  delete() {
    // tslint:disable-next-line:max-line-length
    this.httpClient.delete<any>(`${this.sharedService.URL}/dbMethodOfPayment?SessionID=${this.sessionId}&ID=${this.paymentId}`).subscribe(Response => {
      if (Response.dbMethodOfPayment_response.ServiceResults[0].hasOwnProperty('ERRORDESCRIPTION')) {
        notify('Cannot delete this record. It is linked to other records in the database.', 'error', 5000);
      } else {
        this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successDelete);
        this.location.back();
      }
    });
  }

  toggle(data) {
    if (data === true) {
      this.popupVisible = true;
    } else {
      this.popupVisible = false;
    }
  }
}
